import PageErrorIcon from "../assets/svg/page-error-icon";
import { P2Button, P2Breadcrumb } from "react-bootstrap-common-script";
import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
const Page404 = () => {
  const [breadcrumbMarginLeft, setBreadcrumbMarginLeft] = useState<number>(0);
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const navigate = useNavigate();

  const handleNavigation = useCallback(() => {
        navigate("/");
  }, [navigate]);
  useEffect(() => {
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };

    return () => {
      window.onresize = () => {};
    };
  }, []);

  useEffect(() => {
    const svgIcon = document.querySelector(
      ".polymer-error-page-content-container svg"
    );
    if (windowWidth <= 768) {
      setBreadcrumbMarginLeft(15);
      return;
    }
    setBreadcrumbMarginLeft(svgIcon?.getBoundingClientRect().left ?? 0);
  }, [windowWidth]);
  return (
    <div className="polymer-error-page-container">
      {" "}
      <div style={{ margin: "40px 0", marginLeft: breadcrumbMarginLeft }}>
        <P2Breadcrumb
          pages={[
            { title: "Home", link: "https://www.hdb.gov.sg/" },
            { title: "Page not found", link: "" },
          ]}
        />
      </div>
      <div className="polymer-error-page-content-container polymer-error-page-content-container__404">
        <PageErrorIcon />
        <div>
          <h2>We couldn't find the page.</h2>
          <p style={{ marginBottom: 0 }}>
            The page you are looking for may have been moved or no longer
            exists.
          </p>
          <p>
            You may want to try searching above or head back to our homepage.
          </p>
          <p>
            If you have further enquiries, you may <a href="#" className="polymer-text-links">contact us.</a>
          </p>
        </div>
      </div>
      <div className="polymer-error-page-button-container">
        <P2Button variant="primary-1" onClick={handleNavigation}>Back to Homepage</P2Button>
      </div>
    </div>
  );
};

export default Page404;
